import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ 
  name: 'booleanFormatterPipe',
  standalone: false
})
export class BooleanFormatterPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? "Yes" : "No";
  };
}
